import React, { Component } from 'react';
import './Stats.css';
import NavBar from '../../shared/NavBar';
import {Col, Row, Button, Input} from 'reactstrap';
import Notifications, {notify} from 'react-notify-toast';

import {connect} from "react-redux";


class Stats extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reps: [],
            queue: [],
            loading: true,
            teams: [],
            selectedTeam: '',
            selectedGroup: '',
            groups: [],
            closers: [],
            setters: [],
            assignedClosers: [],
            currentGroupInfo: '',
            newTeamTitle: '',
            currentTeamId: ''
        };

        this.addToQueue = this.addToQueue.bind(this);
        this.moveUp = this.moveUp.bind(this);
        this.moveDown = this.moveDown.bind(this);
        this.removeRep = this.removeRep.bind(this);
        this.save = this.save.bind(this);
        this.getTeamInfo = this.getTeamInfo.bind(this);
        this.adminSave = this.adminSave.bind(this);
        this.editGroup = this.editGroup.bind(this);

        this.state.selectedTeam = this.props.state.user.team_id;
    }

    componentDidMount(){




        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_all_teams"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                teams: data.data
            });

        }.bind(this));


        if (this.props.state.user.permission !== 'admin'){

            this.setState({
                selectedTeam: this.props.state.user.team_id
            });

            fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "method":"get_teams",
                        "account_id": this.state.selectedTeam
                    }
                )
            }).then(function(response) {
                return response.json();
            }).then(function(data) {



                this.setState({
                    reps: data.data,
                    loading: false
                });

                for (let i = 0; i < data.data.length; i++){

                    if (data.data[i]['account_id'] === this.state.selectedTeam){
                        this.setState({
                            currentTeamId: data.data[i]['account_id'],
                            groups: data.data[i]['groups'],
                            currentGroupInfo: data.data[i]['groups'][0]
                        });

                    }

                }
            
                this.loadGroup();

            }.bind(this));

        } else {

            this.setState({
                selectedTeam: this.props.state.user.team_id
            });

            fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "method":"get_teams",
                        "account_id": this.state.team_id
                    }
                )
            }).then(function(response) {
                return response.json();
            }).then(function(data) {



                this.setState({
                    reps: data.data,
                    loading: false
                });

                this.loadGroup();

            }.bind(this));

        }



        // this.setState({
        //     loading: true
        //  });
        //  this.setState({loading: true});
        //  fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
        //      method: 'post',
        //      body: JSON.stringify(
        //          {
        //              "method":"get_teams",
        //              "account_id": "001o00000116xdAAAQ"
        //          }
        //      )
        //  }).then(function(response) {
        //      return response.json();
        //  }).then(function(data) {


        //      this.setState({
        //          reps: data.data,
        //          loading: false
        //      });
             
        //      for (let i = 0; i < data.data.length; i++){
        //          if (data.data[i]['account_id'] === "001o00000116xdAAAQ"){
        //              this.setState({
        //                  currentTeamId: data.data[i]['account_id'],
        //                  groups: data.data[i]['groups']
        //              });
        //          }
        //      }
        //      this.setState({
        //         currentGroupInfo: this.state.groups[0]
        //      });
        //      this.loadGroup();
        //  }.bind(this));

        //  this.setState({selectedTeam: "001o00000116xdAAAQ"});


    
        // fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
        //     method: 'post',
        //     body: JSON.stringify(
        //         {
        //             "method":"get_group_info",
        //             "account_id": "001o00000116xdAAAQ",
        //             "group_id": "001o00000116xdAAAQ"
        //         }
        //     )
        // }).then(function(response) {
        //     return response.json();
        // }).then(function(data) {

        //     this.setState({
        //         currentGroupInfo: data.data,
        //         closers: data.data.closers,
        //         setters: data.data.setters,
        //         assignedClosers: data.data['assignment'],
        //         loading: false
        //     });


        // }.bind(this));

        // console.log(this.state.setters);

    }


    loadGroup = () => {


        
        this.setState({
            setters: [],
            assignedClosers: [],
            loading: true,
        });


        console.log(this.props.state.user.team_id);
        console.log(this.state.selectedTeam);
        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_group_info",
                    "account_id": this.state.selectedTeam,
                    "group_id": this.state.currentGroupInfo['group_id']
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            console.log("whaaat");
            console.log(data);

            this.setState({
                currentGroupInfo: data.data,
                closers: data.data.closers,
                setters: data.data.setters,
                assignedClosers: data.data['assignment'],
                loading: false
            });


        }.bind(this));

        

    };

    editGroup(event){

        this.setState({
            setters: [],
            assignedClosers: [],
            loading: true,
        });

        let index = event.target.value;
        let data = this.state.groups[index];


        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_group_info",
                    "account_id": data['account_id'],
                    "group_id": data['group_id']
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            this.setState({
                currentGroupInfo: data.data,
                closers: data.data.closers,
                setters: data.data.setters,
                assignedClosers: data.data['assignment'],
                loading: false
            });


        }.bind(this));



        this.setState({selectedGroup: event.target.value});

    }

    editTeamTitle = (event) => {

        const target = event.target;
        const name = target.name;

        this.setState({
            [name]:target.value
        });

    };



    //change team
    getTeamInfo(event){


        this.setState({
           loading: true
        });
        let accountId = event.target.value;
        this.setState({loading: true});
        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_teams",
                    "account_id": this.state.selectedTeam
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            console.log(data);

            this.setState({
                reps: data.data,
                loading: false
            });

            for (let i = 0; i < data.data.length; i++){

                if (data.data[i]['account_id'] === accountId){


                    this.setState({
                        currentTeamId: data.data[i]['account_id'],
                        groups: data.data[i]['groups']
                    });

                }

            }

            
            this.setState({
               currentGroupInfo: this.state.groups[0]
            });


            
            console.log("356");
            this.loadGroup();
    

        }.bind(this));

        this.setState({selectedTeam: event.target.value});



    }

    addToQueue(event, param){
        this.setState({
            queue: [...this.state.queue, event]
        });
    }

    moveUp(event){

        let new_array = [];
        if (event > 0){
            for (let i = 0; i < this.state.assignedClosers.length; i++){
                if (i + 1 === event){
                    new_array.push(this.state.assignedClosers[i + 1]);
                } else if (i === event) {
                    new_array.push(this.state.assignedClosers[i - 1]);
                } else {
                    new_array.push(this.state.assignedClosers[i]);
                }
            }

            this.setState({
                assignedClosers: new_array
            });
        }
    }

    moveDown(event){

        let new_array = [];
        if (event < this.state.assignedClosers.length - 1){

            for (let i = 0; i < this.state.assignedClosers.length; i++){
                if (i - 1 === event){
                    new_array.push(this.state.assignedClosers[i - 1]);
                } else if (i === event) {
                    new_array.push(this.state.assignedClosers[i + 1]);
                } else {
                    new_array.push(this.state.assignedClosers[i]);
                }
            }

            this.setState({
                assignedClosers: new_array
            });
        }

    }

    removeRep(event){
        let new_array = this.state.assignedClosers;
        new_array.splice(event, 1);
        this.setState({
            assignedClosers: new_array
        });

    }

    save(){

        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"set_list",
                    "account_id": this.state.selectedTeam,
                    "data": this.state.queue
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            if (data.success === true){
                notify.show('New Rep Priority Saved!', 'success');
            }

        });
    }

    adminSave(){

        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"update_group_assignment",
                    "account_id": this.state.currentGroupInfo['account_id'],
                    "group_id": this.state.currentGroupInfo['group_id'],
                    "data": this.state.assignedClosers
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('Group Updated!', 'success');

        }.bind(this));

    }




    updateGroupAssignment = (item) => {


       let closers = [...this.state.assignedClosers, item];


        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"update_group_assignment",
                    "account_id": this.state.currentGroupInfo['account_id'],
                    "group_id": this.state.currentGroupInfo['group_id'],
                    "data": closers
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {


            this.setState({
                assignedClosers: closers
            });

            this.loadGroup();


        }.bind(this));





    };

    assignToGroup = (item) => {

        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"assign_setter_to_group",
                    "account_id": item.account_id,
                    "group_id": this.state.currentGroupInfo['group_id'],
                    "sfid": item.sfid
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('Setter assigned to this group!', 'success');
            this.loadGroup();

        }.bind(this));


    };

    unassign = (item) => {

        let data = {
            "method":"unassign_setter_from_group",
            "group_id": this.state.currentGroupInfo['group_id'],
            "sfid": item.sfid
        };


        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"unassign_setter_from_group",
                    "group_id": this.state.currentGroupInfo['group_id'],
                    "sfid": item.sfid
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('Setter unassigned!', 'success');
            this.loadGroup();

        }.bind(this));

    };

    addTeam = () => {


        let data = {
            "method":"create_rr_group",
            "account_id": this.state.currentTeamId,
            "name": this.state.newTeamTitle
        };



        fetch('https://dev.iondeveloper.com/api/rep/round-robin/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                data
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            notify.show('Added Group', 'success');

        }.bind(this));

    };

    render() {



        let multi = [];


        if (this.props.state.user.email === 'egraff@ionsolar.com'){

            multi.push(
                <div key={0} className="queue-box">
                    <div className="add-label">
                        Team Select
                    </div>
                    <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none" className="select-box">
                        <option  value="001o0000010EHdSAAW">Austin Sales Team</option>
                        <option  value="0011N00001g8KwUQAU">San Antonio Sales Team</option>
                    </select>
                </div>
            );

        }

        if (this.props.state.user.email === 'dandrus@ionsolar.com'){

            multi.push(
                <div key={0} className="queue-box">
                    <div className="add-label">
                        Team Select
                    </div>
                    <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none" className="select-box">
                        <option value="001o0000016mZ7bAAE">North Denver Sales Team</option>
                        <option value="001o00000116xdAAAQ">Denver Sales Team</option>
                        <option value="001o0000010DtdwAAC">Colorado Springs Sales Team</option>
                        <option value="001o0000017WJuGAAW">New Mexico Sales Team</option>
                        <option value="0011N00001RLEj3QAH">Virginia Sales Team</option>
                    </select>
                </div>
            );

        }

        if (this.props.state.user.email === 'cgrubbs@ionsolar.com'){

            multi.push(
                <div key={0} className="queue-box">
                    <div className="add-label">
                        Team Select
                    </div>
                    <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none" className="select-box">
                        <option value="0011N000017yAllQAE">Vegas 1</option>
                        <option value="0011N00001msjWQQAY">Vegas 2</option>
                    </select>
                </div>
            );

        }



        const closerPool = this.state.closers.map((item, index) =>
            <div key={index} className="queue-rep" onClick={() => this.updateGroupAssignment(item)}>
                <div>
                    <div className="profile-image">
                        <img  src={item.profile} alt=""/>
                    </div>
                    <div className="add-rep">
                        +
                    </div>
                    <span>{item.fname} {item.lname}</span>
                </div>
            </div>
        );


        const setterPool = this.state.setters.map((item, index) =>
            <div key={index} className="queue-rep" onClick={() => this.addToQueue(item)}>
                <div>
                    <div className="profile-image">
                        <img  src={item.profile} alt=""/>
                    </div>
                    <div className="add-rep">
                        +
                    </div>
                    <span>{item.fname} {item.lname}</span>
                </div>
            </div>
        );


        const closers = this.state.assignedClosers.map((item, index) =>
            <div key={index} className="queue-rep">
                <div>
                    <div className="queue-index">{index + 1}</div>
                    <div className="profile-image">
                        <img  src={item.profile} alt=""/>
                    </div>
                    <span>{item.fname}</span> <br></br> <span>{item.lname}</span>
                    <div className="arrows">
                        <span className="up-arrow" onClick={() => this.removeRep(index)}>&#10006;</span>
                        <span className="up-arrow" onClick={() => this.moveUp(index)}>&#x21E7;</span>
                        <span onClick={() => this.moveDown(index)}>&#x21E9;</span>
                    </div>
                </div>
            </div>
        );

        const setters = this.state.setters.map((item, index) =>
            <div key={index} className="queue-rep">
                <div>
                    <div className="profile-image">
                        <img  src={item.profile} alt=""/>
                    </div>
                    <span>{item.fname} {item.lname}</span>
                    <div>
                        { item.assignedToThis ? <Button style={{padding: 2, paddingLeft: 5, paddingRight: 5, fontSize: 10, border: "none", backgroundColor: "rgba(255, 152, 0, 0.85)"}} onClick={() => this.unassign(item)}>Unassign</Button> : ''}
                        {item.isAssigned ? (
                                <span> {item.setsFor}</span>
                        ) : (
                            <div>
                                <Button style={{padding: 2, paddingLeft: 5, paddingRight: 5, fontSize: 10, border: "none", backgroundColor: "rgba(255, 152, 0, 0.85)"}} onClick={() => this.assignToGroup(item)}>Assign to this group</Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );


        const teams = this.state.teams.map((item, index) =>
            <option key={index} value={item.account_id}>{item.name}</option>
        );

        const groups = this.state.groups.map((item, index) =>
            <option key={index} value={index}>{item.name}</option>
        );

        let loader = [];
        if (this.state.loading === true){
            loader.push(
                <div key={0} className="loader">Loading...</div>
            );
        }

        let selectTeam = (<div></div>);
        if (this.props.state.user.permission !== 'admin'){

            selectTeam = (
                <select disabled value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none"
                        className="select-box">
                    {teams}
                </select>
            );
        } else {
            selectTeam = (
                <select value={this.state.selectedTeam} onChange={this.getTeamInfo} selected="none"
                        className="select-box">
                    {teams}
                </select>
            )

        }

 
  
        return (
            <div className="login-bg-color">
                <NavBar />
                <div className="container">
                    <img className="section-header" src="https://dev.iondeveloper.com/adminimages/roundrobin.png" />
                    <Notifications />
                    <Row>
                        <Col xs="12" sm="12" md="6" lg="4" className="need-width">
                            <div className="queue-box">
                                {selectTeam}
                                <select value={this.state.selectedGroup} onChange={this.editGroup} selected="none" className="select-box">
                                    {groups}
                                </select>
                                <div className="add-label">
                                    Add Group
                                </div>
                                <div>
                                    <Input style={{width: "100%"}} type="text" className="add-group-button" name="newTeamTitle" value={this.state.newTeamTitle} onChange={this.editTeamTitle} />
                                </div>
                                <div>
                                    <Button style={{width: "100%", marginTop: 10}} type="text" onClick={() => this.addTeam()} >Add</Button>
                                </div>
                            </div>
                            <div className="queue-box">
                                <div className="add-label">
                                    Closer Pool
                                </div>
                                {closerPool}
                            </div>
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4">
                            <div className="rep-queue">
                                <div className="add-label">
                                    ION Round Robin
                                </div>
                                <div>
                                    <Button onClick={() => this.adminSave()} className="robin-save">Save</Button>
                                </div>
                                <h5>Assigned Closers</h5>
                                <div className="added-rep">
                                    { this.state.loading ? loader : ''}
                                    {closers}
                                </div>
                            </div>
                        </Col>
                        <Col xs="12" sm="12" md="12" lg="4">
                            <div className="rep-queue">
                                <h5>Setters</h5>
                                <div className="added-rep">
                                    {setters}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );   
        
    }

}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Stats);


// WEBPACK FOOTER //
// ./src/components/pages/Stats/Stats.js